import { z } from 'zod';
import { baseUserSchema } from '~/util/types/users';

export const directMergeParamsSchema = z.object({
    primary_user: baseUserSchema.nullable().default(null),
    secondary_user: baseUserSchema.nullable().default(null),
});

export type directMergeParamsType = z.infer<typeof directMergeParamsSchema>;

export const defaultDirectMergeParams = directMergeParamsSchema.parse({});
